<div id="login" class="learnspace-theme">
  <div id="login-form-wrapper">
    <div class="stepper-container">
      <mat-horizontal-stepper [linear]="true" #stepper>
        <mat-step>
          <div class="step1">
            <div class="logo">
              <img src="assets/wonda/wonda-gradient.svg">
            </div>
            <div class="title">{{ loginMessage }}</div>
            <div class="password-login">
              <form name="loginForm" [formGroup]="loginForm" novalidate>
                <mat-form-field>
                  <input matInput placeholder="Email" formControlName="email">
                  <mat-error *ngIf="loginForm.get('email').hasError('required')">
                    Email is required
                  </mat-error>
                  <mat-error *ngIf="!loginForm.get('email').hasError('required') &&
                                loginForm.get('email').hasError('email')">
                    Please enter a valid email address
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <input matInput type="password" placeholder="Password" formControlName="password">
                  <mat-error>
                    Password is required
                  </mat-error>
                </mat-form-field>
                <div *ngIf="loginError" style="color:black; text-align: center">{{ loginError }}</div>
              </form>
              <button (click)="mailLogin()" mat-raised-button color="primary" class="login-button submit-button"
                aria-label="LOG IN" [disabled]="loginForm.invalid">
                LOGIN
              </button>
              <button mat-button color="primary" (click)="resetPassword()">
                FORGOT PASSWORD?
              </button>
            </div>
            <div class="light-text">OR</div>
            <div class="other-login">
              <button mat-stroked-button color="primary" (click)="quickLogin('google')">
                <img src="assets/svg/google-blue-logo.svg">
                LOGIN WITH GOOGLE
              </button>
              <button mat-stroked-button color="primary" (click)="quickLogin('microsoft')">
                <img src="assets/svg/microsoft-blue-logo.svg">
                LOGIN WITH MICROSOFT
              </button>
              <button (click)="ssoFlow(stepper)" mat-stroked-button color="primary">
                <img src="assets/svg/sso-blue-logo.svg">
                LOGIN WITH SSO
              </button>
            </div>
            <div class="other-links">
              <div class="light-text"> NO ACCOUNT YET?</div>
              <button mat-stroked-button color="primary" [routerLink]="['/signup']">
                SIGN UP
              </button>
            </div>
          </div>
        </mat-step>
        <mat-step>
          <search-hub-by-domain></search-hub-by-domain>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </div>

</div>